export const SET_CERT_APPLICATION_STATUS = 'SET_CERT_APPLICATION_STATUS';
export const SET_ACE_CERT_APPLICATION_STATUS = 'SET_ACE_CERT_APPLICATION_STATUS';
